import styled from 'styled-components';

export const UploadWrapper = styled.div``;

export const UploadContent = styled.div`
  background-color: #fbfbfb;
  border: 1px #48a5fd dashed;
  width: 100%;
  padding: 28px;
  border-radius: 4px;
  outline: 0;
  text-align: center;
  h4 {
    font-size: 18px;
    line-height: 20px;
    font-weight: 700;
    color: #4a4a4a;
    margin-bottom: 8px;
  }
`;
export const UploadCont = styled.div`
  outline: 0;
  .mtop10: {
    margin-top: 10px;
  }
`;
export const Description = styled.p`
  font-size: 12px;
  line-height: 14px;
  color: #777777;
  margin-bottom: 32px;
  span {
    font-weight: 700;
  }
`;
export const Drag = styled.p`
  display: flex;
  justify-content: center;
  margin: 28px 0 16px 0;
  img {
    width: 56px;
  }
`;
export const Or = styled.p`
  font-size: 12px;
  line-height: 14px;
  color: #9b9b9b;
  margin-bottom: 16px;
`;
export const SelectBtn = styled.button`
  width: 100%;
  height: 37px;
  background-color: #fff;
  border: 1px #008cff solid;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: 0;
  cursor: pointer;
  font-size: 14px;
  text-transform: uppercase;
  color: #008cff;
  font-family: 'Lato';
  font-weight: 700;
  position: relative;
  ${p =>
    p.disabled &&
    `
        color: rgb(0, 140, 255, 0.2);
    `}
`;
export const Info = styled.p`
  font-size: 12px;
  line-height: 14px;
  color: #4a4a4a;
  margin-top: 10px;
`;
export const UploadedFileItemCont = styled.div`
  width: 282px;
  margin: 0 auto;
`;
export const UploadedFileItem = styled.div`
  background-color: #f7f7f7;
  border: 1px #d8d8d8 solid;
  border-radius: 4px;
  padding: 16px;
  display: flex;
  align-items: center;
  margin-top: 16px;
  text-align: left;
  ${p =>
    p.isError &&
    `
        border-color: #FF888C;
    `}
`;
export const ErrorMsg = styled.p`
  font-size: 12px;
  line-height: 14px;
  color: #eb2026;
  margin-top: 3px;
  text-align: left;
`;
export const FilteTypeIcon = styled.span`
  flex-shrink: 0;
  margin-right: 10px;
`;
export const FileName = styled.p`
  font-size: 12px;
  line-height: 14px;
  color: #000000;
`;
export const FileSize = styled.p`
  font-size: 12px;
  line-height: 14px;
  color: #9b9b9b;
  margin-top: 3px;
`;
export const UploadedFileItemDesc = styled.div`
  flex: 1;
`;
export const ViewInvoice = styled.span`
  font-size: 12px;
  font-weight: 900;
  color: #008cff;
  cursor: pointer;
  margin-right: 16px;
  margin-left: 10px;
`;
